module.exports = __webpack_public_path__ + "img/rowquestion.4126cfef.png";